import Swiper from 'swiper/bundle';
import fancybox from "@fancyapps/fancybox";

window.Swiper = Swiper;

$('[data-fancybox="gallery"]').fancybox({

});

$(document).ready(function() {
    if ($('.gallery-thumbs').length) {
        var galleryThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 10,
            slidesPerView: 3,
            width: 320,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
    }


    var galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper: galleryThumbs,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

});